package com.dotdrives.web.pages.giving

import com.dotdrives.model.*
import kotlinx.serialization.json.*
import react.FC
import react.Key
import react.useState
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.aside
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.form
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.progress
import react.dom.html.ReactHTML.span
import react.dom.html.ReactHTML.strong
import web.cssom.ClassName
import web.html.button

internal val GivingStory =
    FC<GivingSectionProps> { props ->
        val (failedLogo, setFailedLogo) = useState<String?>(null)
        val (expanded, setExpanded) = useState(false)
        val state = props.state
        val form = state.form ?: return@FC
        aside {
            className = ClassName("give-story")
            val background = form.config.design.backgroundColor
            if (background != null && Regex("#[0-9a-fA-F]{6}").matches(background)) {
                // Brand accent only; dark story surface keeps text consistently readable.
                asDynamic().style = js("({})")
                asDynamic().style["borderTopColor"] = background
            }
            div {
                className = ClassName("give-brand")
                form.config.design.logoUrl?.takeIf { safeGivingUrl(it) && it != failedLogo }?.let { logo ->
                    img {
                        src = logo
                        alt = form.orgName
                        className = ClassName("give-logo")
                        onError = { setFailedLogo(logo) }
                    }
                }
                +form.orgName
            }
            div {
                className = ClassName("give-eyebrow")
                +"GIVE WITH PURPOSE"
            }
            // Legacy headlines can contain whole paragraphs. Preserve the original text,
            // but use the campaign name as the heading so it remains readable on small screens.
            val paragraphHeadline = form.headline.length > 180
            h1 { +(if (paragraphHeadline) form.name else form.headline.ifBlank { form.name }) }
            val paragraphs = if (paragraphHeadline) listOf(form.headline, form.config.story) else listOf(form.config.story)
            val collapsible = paragraphs.sumOf { it.length } > 240
            div {
                className = ClassName("give-story-text" + (if (collapsible) " collapsible" else "") + if (expanded) " expanded" else "")
            paragraphs.filter(String::isNotBlank).forEachIndexed { index, text ->
                p {
                    key = index.toString().unsafeCast<Key>()
                    className = ClassName("give-story-copy")
                    val font = form.config.design.font
                    if (font in listOf("Nunito Sans", "Quicksand", "IBM Plex Mono")) {
                        asDynamic().style = js("({})")
                        asDynamic().style["fontFamily"] = font
                    }
                    +text
                }
            }
            }
            if (collapsible) button {
                type = web.html.ButtonType.button
                className = ClassName("give-story-expand")
                ariaExpanded = expanded
                onClick = { setExpanded(!expanded) }
                +if (expanded) "Show less" else "Read the full story"
            }
            form.progress
                ?.takeIf { it.goal > 0 }
                ?.let { progress ->
                    div {
                        className = ClassName("give-progress")
                        div {
                            className = ClassName("give-progress-numbers")
                            strong { +money(progress.received) }
                            span { +"of ${money(progress.goal)} goal" }
                        }
                        progress {
                            value = progress.received.coerceIn(0.0, progress.goal)
                            max = progress.goal
                            ariaLabel = "Campaign giving progress"
                        }
                        p { +"Received toward this campaign" }
                    }
                }
            div {
                className = ClassName("give-story-foot")
                +"Powered by Dot Drives"
            }
        }
    }
